var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCopy9Parking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-296-202H854v754H-296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.339 17.578h98.039v98.04H14.339z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M76.673 96.321V82.853a4.49 4.49 0 0 0-1.497-3.352L72.737 67.89a7.482 7.482 0 0 0-7.332-5.986H31.077a7.482 7.482 0 0 0-7.333 5.986l-2.439 11.612a4.49 4.49 0 0 0-1.496 3.352v13.468c-.827 0-1.497.67-1.497 1.497v5.985c0 .827.67 1.497 1.497 1.497v4.489c0 .826.67 1.496 1.496 1.496h7.482c.827 0 1.496-.67 1.496-1.496v-4.49h35.915v4.49c0 .826.67 1.496 1.496 1.496h7.482c.827 0 1.497-.67 1.497-1.496v-4.49c.826 0 1.496-.67 1.496-1.496v-5.985c0-.827-.67-1.497-1.496-1.497zm-47.886 5.986h-7.482v-2.993h53.871v2.993H28.787zm-2.11-33.834a4.49 4.49 0 0 1 4.4-3.577h34.328a4.49 4.49 0 0 1 4.399 3.577l2.035 9.891H24.642l2.035-9.891zm-3.876 14.38c0-.826.67-1.496 1.497-1.496h47.885c.827 0 1.497.67 1.497 1.496v13.468H22.8V82.853zm4.49 25.44H22.8V105.3h4.49v2.993zm46.389 0h-4.49V105.3h4.49v2.993z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M28.787 82.853a4.49 4.49 0 1 0 0 8.979 4.49 4.49 0 0 0 0-8.979zm0 5.986a1.496 1.496 0 1 1 0-2.993 1.496 1.496 0 0 1 0 2.993zM67.694 82.853a4.49 4.49 0 1 0 0 8.979 4.49 4.49 0 0 0 0-8.979zm0 5.986a1.496 1.496 0 1 1 0-2.993 1.496 1.496 0 0 1 0 2.993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.716 82.853h-20.95a1.496 1.496 0 1 0 0 2.993h20.95a1.496 1.496 0 0 0 0-2.993zM58.716 87.343h-20.95a1.496 1.496 0 1 0 0 2.992h20.95a1.496 1.496 0 0 0 0-2.992zM58.716 91.832h-20.95a1.496 1.496 0 1 0 0 2.993h20.95a1.496 1.496 0 1 0 0-2.993z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M106.601 21.5H73.68c-.827 0-1.497.67-1.497 1.496v32.922c0 .826.67 1.496 1.497 1.496H85.65v52.375c0 .826.67 1.496 1.497 1.496h5.985c.827 0 1.497-.67 1.497-1.496V57.414H106.6c.826 0 1.496-.67 1.496-1.496V22.996c0-.826-.67-1.496-1.496-1.496zm-14.964 86.793h-2.993V57.414h2.993v50.879zm13.468-53.872H75.176V24.493h29.929V54.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M85.651 51.428c.827 0 1.497-.67 1.497-1.496V39.457h4.489a5.986 5.986 0 1 0 0-11.971H85.65c-.826 0-1.496.67-1.496 1.496v20.95c0 .827.67 1.496 1.496 1.496zm1.497-20.95h4.489a3.217 3.217 0 0 1 2.185.883 2.993 2.993 0 0 1 0 4.22c-.59.56-1.372.876-2.185.883h-4.49V30.48z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCopy9Parking);
export default __webpack_public_path__ + "static/media/icons-copy-9-parking.e6ba3aed990cca62e5327eb7affc7d3f.svg";
export { ForwardRef as ReactComponent };